module.exports = __webpack_public_path__ + "static/b860f9a4-4a2e-4794-90a3-0499a11c286d-7470d7938619c1485d696f58f6c38ea9.webp";